import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const FinanceDashboardMcoPbmTrendChart = ({ periodDim, startPeriod, endPeriod, periodicity, prodIds }) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();
  const { navigateTo } = useNavState();

  useEffect(() => {
    const reqParam = { periodDim, startPeriod, endPeriod, periodicity, prodIds };
    rsrc.data('gtn', 'MCO_PBM_TREND_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });
  }, [periodDim, startPeriod, endPeriod, periodicity, prodIds]);

  if (!data) return null;

  const onClick = (clickData) => {
    navigateTo('gtn/mco-pymt', {
      mode: Mode.PERSPECTIVE,
      perspectiveState: {
        dimCodes: [periodDim, 'PBM', 'PROD'],
        dimFilters: {
          EARNED_PERIOD: [data.periodCodeToPeriodId[clickData.category]],
          PROD: prodIds,
        },
      },
    });
  }

  return (
    <CartesianChart
      data={data}
      legend="top"
      yLabel="Payment Amount"
      stacked
      onClick={onClick}
    />
  );
}